export type Translations = typeof fr;

export const fr = {
    testKey: 'testValueFR',
    testKeyNested: { deepTranslation: 'deepTranslationFR' },
    Lang: 'fr',
    Tester: 'Tester',
    rules: {
        welcome: 'Bienvenue !',
        howTo: 'Déplacez-vous avec les flèches du clavier.\nUtilisez espace pour sauter.\nP pour mettre en pause.',
        end: 'Atteignez le dernier niveau afin de\nsauvegarder et partager votre score !',
        start: 'Appuyez sur espace pour commencer',
        runAway: 'Fuyez la nuit !',
    },
    Retour: 'Revenir',
    Editeur: 'Créez votre propre niveau',
    Jeu: 'Jouez au jeu',
    Ou: 'Ou ...',
    Menu: 'Menu',
    Victoire: 'VICTOIRE !',
    Enregistrement: 'Enregistrement du score actuel',
    HowToBack: '(Revenez sur ce menu avec Échap)',
    RaZ: 'RaZ',
    points: 'Points',
    Pseudo: 'Entrez votre pseudo et validez par Entrée !',
    backToMenu: 'Retour au menu',
    Scores: 'Tableau des scores',
    Difficultes: {
        easy: 'Facile',
        normal: 'Normal',
        hard: 'Difficile',
        nightmare: 'Inhumain',
    },
    UnSeul: 'Score / Pseudo / Nombre de niveaux',
};
